import { Component, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import {
  isLargeScreen,
  updateCustomTableHeaders,
} from '../../../../global.variable';
import { Router, ActivatedRoute } from '@angular/router';
import { AppService } from '../../../app.service';
import { LoadingSpinnerService } from '../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { ClientsService } from '../clients/clients.service';
import { SubBillerService } from './sub-biller.service';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { ModalDialogueService } from '../../../shared/components/modal-dialogue/modal-dialogue.service';
import { firstValueFrom } from 'rxjs';
import { ConfirmDialogComponent } from '../../../shared/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'gtapp-sub-biller',
  standalone: false,
  templateUrl: './sub-biller.component.html',
  styleUrl: './sub-biller.component.scss',
})
export class SubBillerComponent implements OnInit, OnDestroy {
  subBillerSearchString: string = '';

  previousSubBillers: number = 0;
  rowsSubBillers: number =
    this.appService.getUserData()?.preferences?.subBiller_page_size || 10;
  pageNumSubBillers: number = 1;
  totalPagesSubBillers: number = 0;
  sortKeySubBillers: any = '';
  searchParamsSubBillers: any;
  totalSubBillerCount: number = 0;

  subBillerPaginationData: any = {};

  subBillerDetailsTableView: any = [];

  subBillerDropDownList: any = [];

  otherParamsSubBillers: any = {
    apiFiltering: true,
  };

  largeView: Boolean = isLargeScreen;

  tableStyle = {
    'overflow': 'auto',
    'max-height': this.largeView ? '75vh' : '65vh',
  };

  selectedSubBillerData: any = {};

  subBillerForm: UntypedFormGroup = new UntypedFormGroup({
    company_name: new UntypedFormControl('', Validators.required),
  });

  constructor(
    private spinnerService: LoadingSpinnerService,
    private appService: AppService,
    private router: Router,
    private route: ActivatedRoute,
    private toasterService: ToasterService,
    private dialogService: ModalDialogueService,
    private subBillerService: SubBillerService,
    private viewContainerRef: ViewContainerRef,
  ) {}

  ngOnDestroy(): void {}
  async ngOnInit() {
    this.formatRouteUrl();
    this.getTableDetails();
    this.getSubBillerListData();
  }

  getSubBillersCount(reqParams: any) {
    let params: any = { get_count: 1, ...reqParams };

    this.subBillerService
      .fetchSubBillerList(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.otherParamsSubBillers = {
            ...this.otherParamsSubBillers,
            paginationData: {
              totalRows: response?.total_count,
              previousRows: this.previousSubBillers,
              rows: this.rowsSubBillers,
              pageNum: this.pageNumSubBillers,
              totalPages: this.totalPagesSubBillers,
            },
          };

          this.totalSubBillerCount = Math.max(
            response?.total_count,
            this.totalSubBillerCount,
            0,
          );
        }
      });
  }

  getSubBillerListData(getCount = true) {
    let params: any = {};
    if (this.rowsSubBillers) {
      params['rows'] = this.rowsSubBillers;
      let userData =
        this.appService.getUserData()?.preferences?.subBiller_page_size;
      if (userData?.preferences) {
        userData.preferences.subBiller_page_size = this.rowsSubBillers;
        this.appService.setUserData(userData);
      }
    }

    if (this.previousSubBillers) {
      params['previous'] = this.previousSubBillers;
    }
    if (this.subBillerSearchString) {
      params['search_str'] = this.subBillerSearchString;
    }

    if (this.searchParamsSubBillers) {
      params.search_filters = JSON.stringify(this.searchParamsSubBillers);
    }

    if (this.sortKeySubBillers) {
      params['sort_key'] = this.sortKeySubBillers;
    }

    if (this.subBillerPaginationData?.[this.pageNumSubBillers]?.length) return;
    if (getCount) this.getSubBillersCount(params);

    this.spinnerService.show();
    this.subBillerService
      .fetchSubBillerList(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.subBillerPaginationData[this.pageNumSubBillers] = [
            ...response?.data,
          ];
          this.updateRoutPath();

          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
        }
      });
  }
  onChangePaginationSubBiller(data: any) {
    this.previousSubBillers = data?.paginationData?.previousRows;
    this.pageNumSubBillers = data?.paginationData?.pageNum;
    if (data?.paginationData?.rows != this.rowsSubBillers) {
      this.subBillerPaginationData = {};
    }
    this.rowsSubBillers = data?.paginationData?.rows;

    this.otherParamsSubBillers.paginationData = {
      ...data?.paginationData,
    };
    this.getSubBillerListData(false);
  }
  sortColumnSubBiller(body: any) {
    this.sortKeySubBillers = body?.sortList || [];
    this.searchParamsSubBillers = body?.searchParams || {};
    if (body?.site_id) {
      this.searchParamsSubBillers = {
        ...this.searchParamsSubBillers,
        site_id: body?.site_id,
      };
    }
    this.subBillerSearchString = '';
    this.subBillerPaginationData = {};
    this.getSubBillerListData(false);
  }
  searchColumnSubBiller(event: any) {
    this.searchParamsSubBillers = event?.searchParams || {};
    if (event?.site_id) {
      this.searchParamsSubBillers = {
        ...this.searchParamsSubBillers,
        site_id: event?.site_id,
      };
    }
    this.clearValues();
    this.getSubBillerListData();
  }
  clearValues() {
    this.previousSubBillers = 0;
    this.pageNumSubBillers = 1;
    this.subBillerSearchString = '';
    this.subBillerPaginationData = {};
  }

  onSubBillerLookup(event: any) {
    if (event.target.value.length > 3) {
      let params: any = { search_str: event.target.value };

      this.subBillerService.fetchSubBillerList(params).subscribe((res: any) => {
        this.subBillerDropDownList = res?.data || [];
      });
    }
  }
  updateRoutPath() {
    this.router.navigate([], {
      fragment: btoa(
        JSON.stringify({
          searchParams: this.searchParamsSubBillers,
          otherParams: this.otherParamsSubBillers,
          subBillerSearchString: this.subBillerSearchString,
        }),
      ),
      queryParams: {},
      replaceUrl: true,
    });
  }
  formatRouteUrl() {
    if (!this.route.snapshot.fragment) return;
    try {
      const urlFragmentDetails = JSON.parse(atob(this.route.snapshot.fragment));
      if (urlFragmentDetails && Object.keys(urlFragmentDetails)?.length) {
        this.searchParamsSubBillers = {
          ...this.searchParamsSubBillers,
          ...(urlFragmentDetails?.searchParams || {}),
        };

        this.subBillerSearchString =
          urlFragmentDetails?.subBillerSearchString || '';
        if (urlFragmentDetails?.otherParams?.paginationData) {
          this.previousSubBillers =
            urlFragmentDetails?.otherParams?.paginationData?.previousRows ||
            this.previousSubBillers;
          this.pageNumSubBillers =
            urlFragmentDetails?.otherParams?.paginationData?.pageNum ||
            this.pageNumSubBillers;
          this.rowsSubBillers =
            urlFragmentDetails?.otherParams?.paginationData?.rows ||
            this.rowsSubBillers;
        }
      }
    } catch (error) {}
  }

  getTableDetails() {
    let tableDetails = [
      {
        header: '',
        name: 'company_name',
        sortKey: 'company_name',
        searchKey: 'company_name',
        tableColumnStyle: {
          'white-space': 'pre-line',
        },
      },
    ];

    updateCustomTableHeaders(tableDetails, this.searchParamsSubBillers);

    this.subBillerDetailsTableView = [...tableDetails];
  }

  async addEditSubBillerView(template: any, subBiller?: any) {
    if (subBiller?.id) {
      this.selectedSubBillerData = subBiller;
      this.subBillerForm.patchValue(subBiller);
    } else {
      this.subBillerForm.reset();
      this.selectedSubBillerData = {};
    }
    const dialogRef = this.dialogService.open(
      template,
      {},
      this.viewContainerRef,
    );
    const dialogResponse = await firstValueFrom(dialogRef.afterClosed());
    if (dialogResponse == 'update') {
      if (this.selectedSubBillerData?.id) {
        // update
        this.subBillerService
          .updateSubBillerDetailById(
            this.selectedSubBillerData?.id,
            this.subBillerForm.value,
            { update_company_name: 1 },
          )
          .then((resp: any) => {
            if (resp?.status != 'success') {
              this.toasterService.setMessage({ errorMessage: resp?.message });
              return;
            }
            this.clearValues();
            this.getSubBillerListData();
          });
      } else {
        this.subBillerService
          .createSubBiller(this.subBillerForm.value, {})
          .then((resp: any) => {
            if (resp?.status != 'success') {
              this.toasterService.setMessage({ errorMessage: resp?.message });
              return;
            }
            this.clearValues();
            this.getSubBillerListData();
          });
      }
    } else if (dialogResponse == 'delete') {
      const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
        data: {
          title: 'Are you sure?',
          message: 'THIS ACTION CANNOT BE UNDONE!',
          btn2Detail: { text: 'Delete', class: 'btn-danger' },
        },
      });
      const confirmResponse = await firstValueFrom(dialogRef.afterClosed());
      if (!confirmResponse) return;
      this.subBillerService
        .updateSubBillerDetailById(
          this.selectedSubBillerData?.id,
          this.subBillerForm.value,
          { delete: 1 },
        )
        .then((resp: any) => {
          if (resp?.status != 'success') {
            this.toasterService.setMessage({ errorMessage: resp?.message });
            return;
          }
          this.clearValues();
          this.getSubBillerListData();
        });
    }
  }
}
